import { render, staticRenderFns } from "./lookApprovalDetail.vue?vue&type=template&id=7839b3a7&scoped=true"
import script from "./lookApprovalDetail.vue?vue&type=script&lang=js"
export * from "./lookApprovalDetail.vue?vue&type=script&lang=js"
import style0 from "./lookApprovalDetail.vue?vue&type=style&index=0&id=7839b3a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7839b3a7",
  null
  
)

export default component.exports